import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { hideSnackbar } from '../api/snackbarSlice';
import { useTranslatedMessages } from '../hooks/useTranslatedMessages';

const emailLinkStyle = { color: 'inherit', textDecoration: 'underline' };

const GlobalSnackbar = () => {
  const dispatch = useDispatch();
  const { open, message, severity, variant, templateKey } = useSelector((state) => state.snackbar);
  const rootUserEmail = useSelector((state) => state.org.org?.root_user_email ?? '');
  const { common } = useTranslatedMessages();

  const handleClose = () => {
    dispatch(hideSnackbar());
  };

  let alertContent = message;

  if (variant === 'access_denied') {
    const templates = common.access_denied ?? {};
    const template =
      templates[templateKey] ??
      templates.action_denied ??
      "You don't have permission to perform this action. Please contact your organization admin ({email}).";
    const email = rootUserEmail.trim();
    const [before, after] = template.split('{email}');
    alertContent = (
      <>
        {before}
        {email ? (
          <a href={`mailto:${email}`} style={emailLinkStyle}>
            {email}
          </a>
        ) : null}
        {after ?? ''}
      </>
    );
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={10000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Alert
        style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
        }}
        onClose={handleClose}
        severity={severity}
        variant="filled"
      >
        {alertContent}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
